import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Checkbox, Chip, FormControl, FormControlLabel, FormGroup, Grid, TextField, makeStyles } from "@material-ui/core";
import { Face } from "@material-ui/icons";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { ClassNameMap } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputMask from "react-input-mask";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import * as yup from "yup";
import { useFormCombos } from "../../../../../../hooks/useFormCombos";
import { actionShowSpinner } from "../../../../../../redux-flow/action/Wrapper/Spinner";
import { ICommitteeOption, getAll } from "../../../../../../services/committePackages.service";
import { getAllCommitteesFromAllPackages, getCommitteeById, newCommittee, updateCommittee } from "../../../../../../services/committees.service";
import { getMembersByName } from "../../../../../../services/formCombos.service";
import AddButton from "../../../../../Common/AddButton";
import Counter from "../../../../../Common/Counter";
import ToastMessage from "../../../../../Common/ToastMessage";
import Header from '../../../components/Header';
import { AddNewParticipantContainer, ButtonsContainer, CommitteeInfoContainer, Container, FieldsContainer, FormContainer, InputsContainer, LeftSideContainer, ParticipantSelectContainer, RightSideContainer, SectionTitle } from './styles';

const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    textTransform: "capitalize",
    padding: "6px 16px",
    minWidth: '200px'
  },
})) as (props?: any) => ClassNameMap<"button" | "root" | "subtitle" | "buttonOutlined" | "spacer">;

const DAYSOFWEEKDEFAULT = [
  { id: 1, name: "monday" },
  { id: 2, name: "tuesday" },
  { id: 3, name: "wednesday" },
  { id: 4, name: "thursday" },
  { id: 5, name: "friday" },
  { id: 6, name: "saturday" },
  { id: 0, name: "sunday" },
];

interface ICommitteesConfigData {
  name: string;
  emailCommittee: string;
  chairpersonId: string;
  chairpersonName: string;
  coChairpersonId: string;
  coChairpersonName: string;
  secretaryId: string;
  secretaryName: string;
  duration: string;
  subordinatedId: string;
  subordinatedName: string;
  frequencyId: string;
  frequencyName: string;
  packageCommittee: string;
  packageCommitteeName: string;
}

interface ICreateCommitteePayload {
  members: {id: string; isHaveRightToVote: boolean}[];
  name: string;
  email: string;
  chairPerson: string;
  cochair: string;
  secretary: string;
  subordinated: string;
  frequency: string;
  daysOfWeek: number[];
  duration: string;
  internal: boolean;
  countInstalers: number;
  countApprovers: number;
  committeePackageId: string;
}

const schema = yup.object().shape({
  name: yup.string().required(),
  chairpersonId: yup.string().required(),
  chairpersonName: yup.string().required(),
  coChairpersonId: yup.string(),
  coChairpersonName: yup.string(),
  secretaryId: yup.string().required(),
  secretaryName: yup.string().required(),
  subordinatedId: yup.string(),
  subordinatedName: yup.string(),
  frequencyId: yup.string().required(),
  frequencyName: yup.string(),
  packageCommittee: yup.string().required(),
  packageCommitteeName: yup.string().required(),
});

const ComitteesConfiguration: React.FC = ({actionShowSpinner}: any) => {
  const location = useLocation<{id?: string}>();
  const { t } = useTranslation();
  const classes = useStyles();  
  const { getFrequency, frequency: frequencyOptions } = useFormCombos();
  
  const { register, handleSubmit, watch, setValue, getValues, formState } = useForm<ICommitteesConfigData>({
    resolver: yupResolver(schema),
  });

  const effectHasRunned = useRef(false);

  const [toastMessage, setToastMessage] = useState({
    open: false,
    content: "",
    type: "",
    autoHideDuration: 4000,
  });
  
  const [duration, setDuration] = useState<string>('');
  const [secretaryNameToSearch, setSecretaryNameToSearch] = useState<string>('');
  const [coChairPersonNameToSearch, setCoChairPersonNameToSearch] = useState<string>('');
  const [chairPersonNameToSearch, setChairPersonNameToSearch] = useState<string>('');
  const [rigthMemberNameToSearch, setRigthMemberNameToSearch] = useState<string>('');
  const [noRigthMemberNameToSearch, setNoRigthMemberNameToSearch] = useState<string>('');
  const [secretaryOptions, setSecretaryOptions] = useState<{ id: string; name: string; positionName: string }[]>([]);
  const [coChairPersonOptions, setCoChairPersonOptions] = useState<{ id: string; name: string; positionName: string }[]>([]);
  const [chairPersonOptions, setChairPersonOptions] = useState<{ id: string; name: string; positionName: string }[]>([]);
  const [rightsVoteMemberOptions, setRightsVoteMemberOptions] = useState<{ id: string; name: string; positionName: string }[]>([]);
  const [noRightsVoteMemberOptions, setNoRightsVoteMemberOptions] = useState<{ id: string; name: string; positionName: string }[]>([]);
  const [packageCommitteOptions, setPackageCommitteesOptions] = useState<ICommitteeOption[]>([]);
  const [noRightVoteMemberToAdd, setNoRightVoteMemberToAdd] = useState<{id: string; name: string}>({} as {id: string; name: string});
  const [rightVoteMemberToAdd, setRightVoteMemberToAdd] = useState<{id: string; name: string}>({} as {id: string; name: string});
  const [rightVoteMembers, setRightVoteMembers] = useState<{id: string; name: string}[]>([]);
  const [noRightVoteMembers, setNoRightVoteMembers] = useState<{id: string; name: string}[]>([]);
  const [committeeId, setCommitteeId] = useState<string | undefined>();
  const [counters, setCounters] = useState<{approval: number; installation: number}>({approval: 0, installation: 0});
  const [daysOfWeek, setDaysOfWeek] = useState<string[]>([]);

  const [committeeListSelect, setCommitteeListSelect] = useState<{id: string; name: string}[]>([]);

 useEffect(() => {    
    const params = new URLSearchParams(location.search);
    const id = params.get('id');

    if(id) {
      setCommitteeId(id);
    }
  }, [location]);

  useEffect(() => {
    const language = localStorage.getItem("i18nextLng");
    
    if(!effectHasRunned.current) {
      getAll().then(({committeePackages}) => {
        setPackageCommitteesOptions(committeePackages)
      }).catch((err: any) => {
        const [ errorMessage ] = err?.response?.data?.errors || [t("softwareManagement.modules.business.errorFetchCommitteePackages")];

        setToastMessage({
          open: true,
          content: errorMessage,
          type: 'error',
          autoHideDuration: 4000,
        });
      });
    }
    
    const fetchCommitteesOptions = async() => {
      const {data, error} = await getAllCommitteesFromAllPackages()

      if(error || !data){
        return;
      }

      setCommitteeListSelect(data?.committees as {id: string; name: string}[]);
    }

    fetchCommitteesOptions();
    getFrequency(language);

    if(committeeId){
      fetchCommittee(committeeId);
    }
  }, [committeeId, effectHasRunned.current]);

  useEffect(() => {
    actionShowSpinner(true);
    
    if (noRigthMemberNameToSearch?.length >= 3) {
      const delayDebounceFn = setTimeout(() => {
        getMembersByName("pt", noRigthMemberNameToSearch).then(res => {
        if (res.error?.length > 0 || !res?.data) {
          setNoRightsVoteMemberOptions([]);
          actionShowSpinner(false);
                
          return;
        }
        actionShowSpinner(false);

        const responseData = res.data as [];
        setNoRightsVoteMemberOptions(responseData);
      });
    }, 1000)
    actionShowSpinner(false);

    return () => clearTimeout(delayDebounceFn)
    } else {
      setNoRightsVoteMemberOptions([]);
    }
  }, [noRigthMemberNameToSearch,]);
  
  useEffect(() => {
    actionShowSpinner(true);
    
    if (secretaryNameToSearch?.length >= 3) {
      const delayDebounceFn = setTimeout(() => {
        getMembersByName("pt", secretaryNameToSearch).then(res => {
        if (res.error?.length > 0 || !res?.data) {
          setSecretaryOptions([]);
          actionShowSpinner(false);
                
          return;
        }

        const responseData = res.data as [];
        actionShowSpinner(false);
            
        actionShowSpinner(false);
        setSecretaryOptions(responseData);
      });
    }, 1000)

      actionShowSpinner(false);
      return () => clearTimeout(delayDebounceFn)
    } else {
      setSecretaryOptions([]);
    }

    actionShowSpinner(false);
  }, [secretaryNameToSearch]);

  useEffect(() => {
    actionShowSpinner(true);
    
    if (coChairPersonNameToSearch?.length >= 3) {
      const delayDebounceFn = setTimeout(() => {
        getMembersByName("pt", coChairPersonNameToSearch).then(res => {
        if (res.error?.length > 0 || !res?.data) {
          setCoChairPersonOptions([]);
          
          actionShowSpinner(false);
          return;
        }

        const responseData = res.data as [];
        setCoChairPersonOptions(responseData);
      });
    }, 1000)
    actionShowSpinner(false);

    return () => clearTimeout(delayDebounceFn)
    } else {
      setCoChairPersonOptions([]);
    }

    actionShowSpinner(false);
  }, [coChairPersonNameToSearch]);

  useEffect(() => {
    actionShowSpinner(true);
    
    if (chairPersonNameToSearch?.length >= 3) {
      const delayDebounceFn = setTimeout(() => {
        getMembersByName("pt", chairPersonNameToSearch).then(res => {
          if (res.error?.length > 0 || !res?.data) {
            setChairPersonOptions([]);
            actionShowSpinner(false);
            
            return;
          }

          const responseData = res.data as [];
          setChairPersonOptions(responseData);
          actionShowSpinner(false);
        });
      }, 1000)

      actionShowSpinner(false);
      return () => clearTimeout(delayDebounceFn)
    } else {
      setChairPersonOptions([]);
    }

    actionShowSpinner(false);
  }, [chairPersonNameToSearch]);

  useEffect(() => {
    actionShowSpinner(true);
    
    if (rigthMemberNameToSearch?.length >= 3) {
      const delayDebounceFn = setTimeout(() => {
        getMembersByName("pt", rigthMemberNameToSearch).then(res => {
        if (res.error?.length > 0 || !res?.data) {
          setRightsVoteMemberOptions([]);
          actionShowSpinner(false);
          
          return;
        }

        const responseData = res.data as [];
        setRightsVoteMemberOptions(responseData);
      });
    }, 1000)

    actionShowSpinner(false);
    return () => clearTimeout(delayDebounceFn)
    } else {
      setRightsVoteMemberOptions([]);
    }

    actionShowSpinner(false);
  }, [rigthMemberNameToSearch]);

  const fetchCommittee = useCallback(async (id: string) => {
    if(!id) return;

    const response = await getCommitteeById(id);

    if(response.error) {
      const errorMessage = response.error.length > 1 ? response.error : t("softwareManagement.modules.business.errorFetchCommittee");

      setToastMessage({
        open: true,
        content: errorMessage,
        type: "error",
        autoHideDuration: 4000,
      });

      return;
    }
    
    const committeeById = response.data as any;

    if(!committeeById) return;

    setValue('name', committeeById.name);
    setValue('chairpersonId', committeeById.chairPerson.id);
    setValue('chairpersonName', committeeById.chairPerson.name);
    setChairPersonNameToSearch(committeeById.chairPerson.name);
    setValue('coChairpersonId', committeeById.cochair.id);
    setValue('coChairpersonName', committeeById.cochair.name);
    setCoChairPersonNameToSearch(committeeById.cochair.name);
    setValue('secretaryId', committeeById.secretary.id);
    setValue('secretaryName', committeeById.secretary.name);
    setSecretaryNameToSearch(committeeById.secretary.name);
    setValue('duration', committeeById.duraction);
    setDuration(String(committeeById.duraction));
    setValue('packageCommittee', committeeById.committeePackageId);
    setValue('packageCommitteeName', committeeById.committeePackageName);
    setValue('emailCommittee', committeeById.email);
    setValue('frequencyId', committeeById.frequency);
    setValue('subordinatedId', committeeById.subordinated);
    setDaysOfWeek(committeeById.daysOfWeek.map((d: any) => d.dayOfWeekId));

    setRightVoteMembers(committeeById.members.filter((member: {isHaveRightToVote: boolean}) => member.isHaveRightToVote));
    setNoRightVoteMembers(committeeById.members.filter((member: {isHaveRightToVote: boolean}) => !member.isHaveRightToVote));

    setCounters({
      approval: committeeById.countApprovers,
      installation: committeeById.countInstalers
    });
  }, []);

  const onSubmit = useCallback(async (data: ICommitteesConfigData) => {
    actionShowSpinner(true);
    const [durationHours, durationMinutes] = duration?.split(':');
    
    const durationValid = durationHours.length === 2 && durationMinutes.length === 2;

    if (!durationValid && durationHours.length > 0) {
      setToastMessage({
        open: true,
        content: t("softwareManagement.modules.committee.invalidDuration"),
        type: "error",
        autoHideDuration: 4000,
      });

      actionShowSpinner(false);
      return;
    }

    const rightVoteMembersFormatted = rightVoteMembers.map(member => ({id: member.id, isHaveRightToVote: true}));
    const noRightVoteMembersFormatted = noRightVoteMembers.map(member => ({id: member.id, isHaveRightToVote: false}));

    const members = [...rightVoteMembersFormatted, ...noRightVoteMembersFormatted];

    const request = {
      members,
      name: data.name,
      email: data.emailCommittee,
      chairPerson: data.chairpersonId,
      cochair: data.coChairpersonId,
      secretary: data.secretaryId,
      subordinated: data.subordinatedId,
      frequency: data.frequencyId,
      daysOfWeek: daysOfWeek.map(day => Number(day)),
      duration: duration,
      internal: false,
      countInstalers: counters.installation,
      countApprovers: counters.approval,
      committeePackageId: data.packageCommittee,
    };    
    
    if(!committeeId) {
      await createCommittee(request);
    }else {
      await handleUpdateCommittee(request);
    }

    actionShowSpinner(false);
  }, [committeeId, duration, counters, daysOfWeek, rightVoteMembers, noRightVoteMembers]);

  const createCommittee = useCallback(async (data: ICreateCommitteePayload) => {
    const {data: createdCommittee, error} = await newCommittee(data) as any;

    if(error.length > 0) {
      setToastMessage({
        open: true,
        content: error || t("softwareManagement.modules.committee.errorCreation"),
        type: 'error',
        autoHideDuration: 4000,
      });

      return;
    }

    setCommitteeId(createdCommittee.data?.id || undefined);

    setToastMessage({
      open: true,
      content: t("softwareManagement.modules.committee.successCreation"),
      type: 'success',
      autoHideDuration: 4000,
    });    
  }, []);

  const handleUpdateCommittee = useCallback(async (data: ICreateCommitteePayload) => {
    if(!committeeId) return;
    
    const { error } = await updateCommittee(committeeId, data);
    
    if(error.length > 0) {
      setToastMessage({
        open: true,
        content: error || t("softwareManagement.modules.committee.errorUpdate"),
        type: 'error',
        autoHideDuration: 4000,
      });

      return;
    }
    
    setToastMessage({
      open: true,
      content: t("softwareManagement.modules.committee.successUpdate"),
      type: 'success',
      autoHideDuration: 4000,
    });
  }, [committeeId]);
  
  const findDayChecked = (idDay: string) => {
    const idx = daysOfWeek.find((item) => {
      return item == idDay;
    });
    
    return !!idx;
  };

  const handleChangeFrequency = useCallback((event: any, dayId: string) => {
    const selectedFrequency = getValues('frequencyId');
    const dayAlreadySelected = findDayChecked(dayId);

    if((
      selectedFrequency == 'S' || 
      selectedFrequency == 'M' ||
      selectedFrequency == 'Q' ||
      selectedFrequency == 'B' ||
      selectedFrequency == 'T' ||
      selectedFrequency == 'A'
    ) && daysOfWeek.length >= 1 && !dayAlreadySelected){
      setToastMessage({
        open: true,
        content:"A frequência selecionada não permite marca mais de um dia da semana",
        type: 'error',
        autoHideDuration: 4000,
      });

      return;
    }

    if(dayAlreadySelected){
      const newDaysOfWeek = daysOfWeek.filter((item) => {
        return item != dayId;
      });

      setDaysOfWeek(newDaysOfWeek);
    }else {
      setDaysOfWeek([...daysOfWeek, dayId]);
    }
  }, [daysOfWeek]);

  const handleAddRightVoteMember = useCallback(() => {
    if(!rightVoteMemberToAdd) return;

    setRightVoteMembers([...rightVoteMembers, {id: rightVoteMemberToAdd.id, name: rightVoteMemberToAdd.name}]);
  }, [rightVoteMemberToAdd]);

  const handleAddNoRightVoteMember = useCallback(() => {
    if(!noRightVoteMemberToAdd) return;
    
    setNoRightVoteMembers([...noRightVoteMembers, {id: noRightVoteMemberToAdd.id, name: noRightVoteMemberToAdd.name}]);
  }, [noRightVoteMemberToAdd]);

  return (
    <Container>
      <Header title={t("softwareManagement.modules.committee.settings")}></Header>

      <FormContainer onSubmit={handleSubmit(onSubmit)}>
        <FieldsContainer>
          <LeftSideContainer>
            <CommitteeInfoContainer>
              <SectionTitle>{t("softwareManagement.modules.committee.infomations")}</SectionTitle>
            
              <InputsContainer container spacing={2}>
                <Grid item lg={6} xs={12}>
                  <TextField
                    autoComplete='nope' 
                    id="nameCommittee"
                    label={t("forms.committee.nameCommittee")}
                    defaultValue=""
                    fullWidth
                    autoFocus={true}
                    required
                    error={!watch('name')} 
                    {...register("name")}
                    InputLabelProps={{ shrink: watch('name') ? true : false }} 
                  />
                </Grid>
                
                <Grid item lg={6} xs={12}>
                  <TextField
                    autoComplete='nope'
                    id="emailCommittee"
                    label={t("menu.managementProfiles.email")}
                    defaultValue=""
                    fullWidth
                    autoFocus={true}
                    {...register("emailCommittee")}
                    InputLabelProps={{ shrink: watch('emailCommittee') ? true : false }} 
                  />
                </Grid>
                
                <Grid item lg={6} xs={12}>
                  <Autocomplete
                    options={chairPersonOptions}
                    getOptionLabel={(options) => `${options.name || ''} ${options.positionName ? `- ${options.positionName}` : ''}`}
                    onChange={(_event, newValue) => {
                      setValue('chairpersonId', newValue?.id || '');
                    }}
                    value={watch('chairpersonId') ? chairPersonOptions.find((participant) => participant.id === watch('chairpersonId')) : null}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("softwareManagement.modules.committee.chairperson")}
                        required
                        error={!watch('chairpersonName')}
                        value={watch('chairpersonName')}
                        {...register("chairpersonName")}
                        onChange={(e: any) => {
                          setChairPersonNameToSearch(e.target.value)
                          setValue('chairpersonName', e.target.value)
                        }}
                      />
                    )}
                  />
                </Grid>
                
                <Grid item lg={6} xs={12}>
                  <Autocomplete
                    options={coChairPersonOptions}
                    getOptionLabel={(options) => `${options.name || ''} ${options.positionName ? `- ${options.positionName}` : ''}`}
                    onChange={(_event, newValue) => {
                      setValue('coChairpersonId', newValue?.id || '');
                    }}
                    value={watch('coChairpersonId') ? coChairPersonOptions.find((participant) => participant.id === watch('coChairpersonId')) : null}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("forms.committee.coChair")}
                        value={watch('coChairpersonName')}
                        {...register("coChairpersonName")}
                        onChange={(e: any) => {
                          setCoChairPersonNameToSearch(e.target.value)
                          setValue('coChairpersonName', e.target.value)
                        }}
                      />
                    )}
                  />
                </Grid>
                
                <Grid item lg={6} xs={12}>
                  <Autocomplete
                    options={secretaryOptions}
                    getOptionLabel={(options) => `${options.name || ''} ${options.positionName || ''}`}
                    onChange={(_event, newValue) => {
                      setValue('secretaryId', newValue?.id || '');
                    }}
                    value={watch('secretaryId') ? secretaryOptions.find((participant) => participant.id === watch('secretaryId')) : null}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("forms.committee.secretary")}
                        required
                        error={!watch('secretaryName')}
                        value={watch('secretaryName')}
                        {...register("secretaryName")}
                        onChange={(event) => {
                          setSecretaryNameToSearch(event.target.value);
                          setValue('secretaryName', event.target.value);
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item lg={6} xs={12}>
                  <Autocomplete
                    options={committeeListSelect}
                    getOptionLabel={(option: {id: string, name: string}) => option.name || ''}
                    onChange={(_event, newValue: {id: string, name: string} | null) => {
                      setValue('subordinatedId', newValue?.id || '');
                    }}
                    value={watch('subordinatedId') ? committeeListSelect.find((subordinatedCommittee: {id: string, name: string}) => subordinatedCommittee.id === watch('subordinatedId')) : null}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t("forms.committee.subordinate")}
                        value={watch('subordinatedName')}
                        {...register("subordinatedName")}
                      />
                    )}
                  />
                </Grid>
              </InputsContainer>
            </CommitteeInfoContainer> 
            
            <CommitteeInfoContainer>
              <SectionTitle>{t("softwareManagement.modules.committee.period")}</SectionTitle>
              
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Grid item lg={12} style={{ marginBottom: 20 }}>
                    <Autocomplete
                      id="frequency"
                      options={frequencyOptions || []}
                      getOptionLabel={(option: any) => option.name || ''}
                      onChange={(_event, newValue: any) => {
                        setValue('frequencyId', newValue?.id || '');
                        setDaysOfWeek([]);
                      }}
                      value={watch('frequencyId') ? frequencyOptions.find((frequency: any) => frequency.id === watch('frequencyId')) : null}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("forms.committee.frequency")}
                          required
                          error={!watch('frequencyId')}
                          value={watch('frequencyName')}
                          {...register("frequencyName")}
                        />
                      )}
                    />                  
                  </Grid>

                  <Grid item lg={12} style={{ marginBottom: 20 }}>
                    <InputMask
                      mask="99:99"
                      maskChar=""                      
                      value={duration}
                      onChange={e => setDuration(e.target.value)}
                    >
                      {() => (
                        <TextField
                          inputProps={{
                            id: "code",
                          }}
                          label={t("forms.committee.duration")}
                          value={duration}
                          fullWidth
                          required
                          error={!duration}
                        />
                      )}
                    </InputMask>
                  </Grid>
                </Grid>
                
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <FormControl component="fieldset">                  
                    <FormGroup>
                      {DAYSOFWEEKDEFAULT.map((item) => (
                        <FormControlLabel
                          key={item.id}
                          control={
                            <Checkbox
                              color="primary"
                              checked={findDayChecked(((String(item.id))))}
                              onChange={(event) => handleChangeFrequency(event, (String(item.id)))}
                              name={item.name}
                            />
                          }
                          label={t(`forms.committee.daysOfWeek.${item.name}`)}
                        />
                      ))}
                    </FormGroup>
                  </FormControl>
                </Grid>
              </Grid>
            </CommitteeInfoContainer> 
            
            <CommitteeInfoContainer>
              <SectionTitle>
                {t("forms.committee.quorum.title")}
              </SectionTitle>

              <Grid container spacing={3}>
                <Grid item lg={6} xs={12}>
                  <Counter              
                    valueDefault={counters.installation}
                    onClickCounter={(installation: number) => setCounters(oldValue => ({...oldValue, installation}))}
                    text={t("forms.committee.quorum.installation")}
                    disabled={false}
                  />
                </Grid>
                
                <Grid item lg={6} xs={12}>
                  <Counter
                    disabled={false}
                    valueDefault={counters.approval}
                    onClickCounter={(approval: number) => setCounters(oldValue => ({...oldValue, approval}))}
                    text={t("forms.committee.quorum.approval")}
                  />
                </Grid>
              </Grid>
            </CommitteeInfoContainer> 
          </LeftSideContainer>

          <RightSideContainer> 
            <CommitteeInfoContainer> 
              <SectionTitle>
                {t("forms.committee.membersVote.title")}
              </SectionTitle>

              <AddNewParticipantContainer>
                <ParticipantSelectContainer>
                  <Autocomplete
                    options={rightsVoteMemberOptions}
                    getOptionLabel={(options) => options.name || ''}
                    onChange={(_event, newValue) => {
                      setRightVoteMemberToAdd(newValue as { id: string, name: string });
                    }}
                    value={rightVoteMemberToAdd}
                    renderInput={(params) => (
                      <TextField
                        onChange={(event) => {
                          setRigthMemberNameToSearch(event.target.value);
                        }}
                        {...params}
                        label={t("forms.committee.membersVote.title")}
                      />
                    )}
                  />
                </ParticipantSelectContainer>

                <AddButton type="button" onClick={() => handleAddRightVoteMember()} />
              </AddNewParticipantContainer>
              
              {rightVoteMembers.map((item, index) => (
                <Grid item lg={12} xs={12} key={`${item} - ${index}`}>
                  <Chip
                    icon={<Face />}
                    label={item.name}
                    onDelete={() => console.log(item.id)}
                    color="primary"
                  />
                </Grid>
              ))}
            </CommitteeInfoContainer> 
            
            <CommitteeInfoContainer> 
              <SectionTitle>
                {t("forms.committee.members.title")}
              </SectionTitle>

              <AddNewParticipantContainer>
                <ParticipantSelectContainer>
                  <Autocomplete
                    options={noRightsVoteMemberOptions}
                    getOptionLabel={(options) => options.name || ''}
                    onChange={(_event, newValue) => {
                      setNoRightVoteMemberToAdd(newValue as { id: string, name: string });
                    }}
                    value={noRightVoteMemberToAdd}
                    renderInput={(params) => (
                      <TextField
                        onChange={(event) => {
                          setNoRigthMemberNameToSearch(event.target.value);
                        }}
                        {...params}
                        label={t("forms.committee.members.title")}
                      />
                    )}
                  />
                </ParticipantSelectContainer>

                <AddButton type="button" onClick={() => handleAddNoRightVoteMember()} />
              </AddNewParticipantContainer>

              {noRightVoteMembers.map((item, index) => (
                <Grid item lg={12} xs={12} key={`${item} - ${index}`}>
                  <Chip
                    icon={<Face />}
                    label={item.name}
                    onDelete={() => console.log(item.id)}
                    color="primary"
                  />
                </Grid>
              ))}
            </CommitteeInfoContainer> 

            <CommitteeInfoContainer> 
              <SectionTitle>
                {t("softwareManagement.modules.committeePackage.title")}
              </SectionTitle>

              <Autocomplete
                id="packageCommittee"
                autoComplete={false}
                options={packageCommitteOptions}
                getOptionLabel={(option) => option.name || ''}
                {...register("packageCommittee")}                
                onChange={(_event, newValue: {id: string, name: string} | null) => {
                  setValue('packageCommittee', newValue?.id || '');
                }}
                value={watch('packageCommittee') ? packageCommitteOptions.find((packageCommitte: {id: string, name: string}) => packageCommitte.id === watch('packageCommittee')) : null}
                renderInput={(params) => (
                  <TextField 
                    {...params} 
                    fullWidth 
                    label={t("softwareManagement.modules.committeePackage.title")}
                    value={watch('packageCommitteeName')}
                    error={!watch('packageCommittee')}
                    required
                    {...register("packageCommitteeName")}
                    onChange={(e: any) => {
                      setValue('packageCommitteeName', e.target.value)
                    }}
                  />
                )}
              />
            </CommitteeInfoContainer> 
          </RightSideContainer> 
        </FieldsContainer>

        <ButtonsContainer>
          <Button
            variant="contained"
            className={classes.button}
            type="submit"
          >
            Salvar
          </Button>
        </ButtonsContainer>
      </FormContainer>
      
      <ToastMessage
        message={toastMessage.content}
        type={toastMessage.type || 'error'}
        open={toastMessage.open}
        close={() => setToastMessage({ ...toastMessage, open: false })}
      />
    </Container>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  actionShowSpinner: (request: any) => dispatch(actionShowSpinner(request)),
});

const ComitteesConfigurationConnection = connect(
  null,
  mapDispatchToProps
)(ComitteesConfiguration);

export default ComitteesConfigurationConnection;